
{
  "fr": {
    "ConfiguratorEditorGraphismTab": {
      "title": "Personnalisation"
    }
  }
}
